module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAPCAYAAAACsSQRAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADSSURBVDiN7ZGhTkNBEEXPbdYSkP0AxDp2sxaxEkmCKQr4in5ODQJRUVnX/YEmNYT3CbiGpxDNGwRpQtq30Oc59swcMaOrmN4Enn7mF+dn96WUXcUDoBCTGbzLWB64S8Q1YkHHohpQ9+oABM1ms376KXPObvvRvsh0h7itRTpGn64mSym7nPNk27YTdfTOmTQV+GpkHwKeaz7E9AB4hZjst9ApOIDKYf/ExI1gXD3sKYSYVsB4NHSxj//IMfsX+xDSbOiygRfgDBqBRzwOjeg71HwBqTs98FC1fIYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/smicon3.png
// module id = ObNp
// module chunks = 1